module.exports = __webpack_public_path__ + "media/images/iconTrendUp__okGreen-a348913f999b9080ae42c7fae92095cf.png";